import Avatar from '../../../components/base/Avatar';
import { useState } from 'react';
import { Card, Dropdown, Form, Nav, Modal, Button, Spinner } from 'react-bootstrap';
import avatar from '../../../assets/img/team/72x72/57.webp';
import FeatherIcon from 'feather-icons-react';
import classNames from 'classnames';
import axios from 'axios';
import { useAuthContext } from '../../../providers/AuthProvider';
import { API } from '../../../config/api';

const ProfileDropdownMenu = ({ className }) => {
  const [loggedInUser, , { logout }] = useAuthContext();
  const [showChangePw, setShowChangePw] = useState(false);
  const [pwForm, setPwForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [pwError, setPwError] = useState('');
  const [pwSuccess, setPwSuccess] = useState('');
  const [pwLoading, setPwLoading] = useState(false);

  const handleChangePw = async () => {
    setPwError('');
    setPwSuccess('');

    if (!pwForm.currentPassword || !pwForm.newPassword) {
      setPwError('Please fill in all fields');
      return;
    }
    if (pwForm.newPassword.length < 8) {
      setPwError('New password must be at least 8 characters');
      return;
    }
    if (pwForm.newPassword !== pwForm.confirmPassword) {
      setPwError('New passwords do not match');
      return;
    }

    setPwLoading(true);
    try {
      await axios.post(`${API.BACKEND}/api/v1/users/change-password`, {
        currentPassword: pwForm.currentPassword,
        newPassword: pwForm.newPassword
      }, {
        headers: {
          'x-auth-token': localStorage.getItem('token'),
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      setPwSuccess('Password changed successfully');
      setPwForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setTimeout(() => {
        setShowChangePw(false);
        setPwSuccess('');
      }, 1500);
    } catch (err) {
      const msg = err.response?.data?.error || err.response?.data?.test || 'Failed to change password';
      setPwError(msg);
    } finally {
      setPwLoading(false);
    }
  };

  return (
    <>
      <Dropdown.Menu
        align="end"
        className={classNames(
          className,
          'navbar-top-dropdown-menu navbar-dropdown-caret py-0 dropdown-profile shadow border border-300'
        )}
      >
        <Card className="position-relative border-0">
          <Card.Body className="p-0">
            <div className="d-flex flex-column align-items-center justify-content-center gap-2 pt-4 pb-3">
              <Avatar src={avatar} size="xl" />
              <h6 className="text-black">{loggedInUser.user?.name}</h6>
              <h6 className="text-black">{loggedInUser.user?.role}</h6>
            </div>
          </Card.Body>
          <Card.Footer className="p-0 border-top">
            <Nav className="nav flex-column my-3">
              <Nav.Item>
                <Nav.Link
                  href="#!"
                  className="px-3"
                  onClick={e => { e.preventDefault(); setShowChangePw(true); }}
                >
                  <FeatherIcon icon="lock" size={16} className="me-2 text-900" />
                  <span>Change Password</span>
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <hr />
            <div className="px-3">
              <button
                onClick={logout}
                className="btn btn-phoenix-secondary d-flex flex-center w-100"
              >
                <FeatherIcon icon="log-out" className="me-2" size={16} />
                Sign out
              </button>
            </div>
            <div className="my-2 text-center fw-bold fs-10 text-600">
              <span className="text-600">ENG App v1.0</span>
            </div>
          </Card.Footer>
        </Card>
      </Dropdown.Menu>

      {/* Change Password Modal */}
      <Modal show={showChangePw} onHide={() => { setShowChangePw(false); setPwError(''); setPwSuccess(''); }} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fs-8">Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {pwError && (
            <div className="alert alert-danger py-2 fs-9">{pwError}</div>
          )}
          {pwSuccess && (
            <div className="alert alert-success py-2 fs-9">{pwSuccess}</div>
          )}
          <Form.Group className="mb-3">
            <Form.Label className="fs-9">Current Password</Form.Label>
            <Form.Control
              type="password"
              value={pwForm.currentPassword}
              onChange={e => setPwForm({ ...pwForm, currentPassword: e.target.value })}
              disabled={pwLoading}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fs-9">New Password</Form.Label>
            <Form.Control
              type="password"
              value={pwForm.newPassword}
              onChange={e => setPwForm({ ...pwForm, newPassword: e.target.value })}
              disabled={pwLoading}
              placeholder="Min. 8 characters"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fs-9">Confirm New Password</Form.Label>
            <Form.Control
              type="password"
              value={pwForm.confirmPassword}
              onChange={e => setPwForm({ ...pwForm, confirmPassword: e.target.value })}
              disabled={pwLoading}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={() => setShowChangePw(false)} disabled={pwLoading}>
            Cancel
          </Button>
          <Button variant="primary" size="sm" onClick={handleChangePw} disabled={pwLoading}>
            {pwLoading ? <Spinner animation="border" size="sm" className="me-1" /> : null}
            Change Password
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProfileDropdownMenu;
